export default __webpack_public_path__ + "static/media/imgAuth.bd1e4377.png";